import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { reducer, state } from '../../../redux/sagas/aws-cognito-redux-saga';
import config from '../../../config';

import SignedUp from './SignedUp';
import SignUpForm2 from './SignUpForm2';
import CodeForm from './CodeForm';

const PASSWORD_MIN_LENGTH = 6;

const passwordValidation = {
  minlength6: value => value && value.length >= PASSWORD_MIN_LENGTH,
  must_contain_at_least_small: value => value.match(/[a-z]+/),
  must_contain_at_least_upper: value => value.match(/[A-Z]+/),
};

const USER_EXISTS_EXEPTION = 'UsernameExistsException';

const mapError = {
  [USER_EXISTS_EXEPTION]: {
    key: 'an_account_with_the_email',
    errorPlace: 'email',
  },
};

const required = {
  required: value => !!value,
};

const inputValidationRule = {
  givenName: {
    ...required,
  },
  familyName: {
    ...required,
  },
  country: {},
  city: {
    ...required,
  },
  jobTitle: {
    ...required,
  },
  yearsExperience: {},
  email: {
    ...required,
    enter_a_vaild_email_address: value => value.match(/^(.+)@(.+\.)(.+)$/),
  },
  password: {
    ...required,
    ...passwordValidation,
  },
  passwordMatch: {
    ...required,
    ...passwordValidation,
  },
};

class SignUpPage extends Component {
  state = {
    givenName: '',
    familyName: '',
    country: '',
    city: '',
    jobTitle: '',
    yearsExperience: '',
    email: '',
    password: '',
    passwordMatch: '',
    code: '',
    salon: '',
    isCodeValid: false,
    loading: false,
    error: '',
    inputValidationError: {},
  };

  componentWillMount() {
    this.props.init();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.auth.hasSignedUp === state.AUTH_UNKNOWN && nextProps.auth.hasSignedUp === state.AUTH_SUCCESS) {
      this.setState({
        loading: false,
        error: '',
      });
    } else if (nextProps.auth.error) {
      const isValidationError = this.isValidationError(nextProps.auth.error.code);

      this.setState({
        loading: false,
        error: isValidationError ? '' : nextProps.auth.error.message,
      });
    }
  }

  // onGetCode = salonCode => {
  //   this.setState(
  //     {
  //       code: salonCode,
  //     },
  //     () => {
  //       this.handleCodeSubmit();
  //     }
  //   );
  // };

  isValidationError(errorCode) {
    const { signUp } = this.props.copy;
    const error = mapError[errorCode] || null;
    if (!error) return false;

    this.inputValidationErrorChange(error.errorPlace, signUp[error.key]);
    return true;
  }

  initValidation() {
    Object.keys(inputValidationRule).map(key => {
      const error = this.inputValidation(key, this.state[key]);
      return error;
    });
  }

  inputValidation(type, value) {
    const rule = inputValidationRule[type];
    const { copy } = this.props;
    const { signUp } = copy;

    if (!rule) return;
    const errorMsg = Object.keys(rule).reduce((prev, key) => {
      if (prev) return prev;
      return !rule[key](value) ? signUp[key] : null;
    }, null);

    if (errorMsg || type !== 'passwordMatch') {
      this.inputValidationErrorChange(type, errorMsg);
      return;
    }

    const { password } = this.state;
    const passwordMatchError = value === password ? null : signUp.passwords_dont_match;
    this.inputValidationErrorChange(type, passwordMatchError);
  }

  inputValidationErrorChange(place, message) {
    const { inputValidationError } = this.state;
    const newValidationError = inputValidationError;
    newValidationError[place] = message;
    this.setState({
      inputValidationError: newValidationError,
    });
  }

  // handleChangePassword = e => {
  //   const { changePassword } = this.props;
  //   const { email, code, password } = this.state;
  //   e.preventDefault();
  //   changePassword(email.toLowerCase(), code, password);
  // };

  handleSignIn = () => {
    const { history, locale } = this.props;
    history.push(`/${locale}/salon-consultation/login`);
  };

  handleInputChange = type => e => {
    const { value } = e.target;
    this.inputValidation(type, value);

    this.setState({
      [type]: value,
      loading: false,
      error: '',
    });
  };

  // handleCodeSubmit = e => {
  handleCodeSubmit = code => {
    // const { code } = this.state;
    const { copy } = this.props;
    const { errorMessage } = copy;

    console.log('[handleCodeSubmit]', code);

    let isValid = false;

    this.setState(
      {
        loading: true,
      },
      () => {
        fetch(`${config.API}/verify`, {
          method: 'post',
          body: JSON.stringify({ code }),
        })
          .then(res => res.json())
          .then(res => {
            if (Object.prototype.hasOwnProperty.call(res, 'errors')) {
              console.log('[NG1]');
              this.setState({
                loading: false,
                error: (errorMessage && errorMessage.retry) || 'Error',
              });
            } else if (res.user[0]) {
              console.log('[OK]');
              isValid = true;
              this.setState({
                isCodeValid: code,
                salon: res.user[0].salon,
                city: res.user[0].city,
                country: res.user[0].country,
                jobTitle: res.user[0].userType,
                loading: false,
                error: '',
              });

              this.initValidation();
            } else {
              console.log('[NG2]');
              this.setState({
                isCodeValid: false,
                loading: false,
                error: (errorMessage && errorMessage.notValidCode) || 'Error',
              });
            }
          })
          .catch(() => {
            if (!isValid) {
              console.log('[NG3]');
              this.setState({
                isCodeValid: false,
                loading: false,
                error: (errorMessage && errorMessage.notValidCode) || 'Error',
              });
            }
          });
      }
    );
  };

  handleSignUp = e => {
    e.preventDefault();
    const {
      email,
      password,
      familyName,
      givenName,
      country,
      city,
      jobTitle,
      yearsExperience,
      salon,
      isCodeValid,
    } = this.state;

    const { copy } = this.props;
    const { signUp } = copy;

    const passwordError = Object.keys(passwordValidation).reduce((prev, key) => {
      if (prev) return prev;
      return !passwordValidation[key](password) ? signUp[key] : null;
    }, null);

    if (passwordError) {
      this.setState({
        loading: false,
        error: passwordError,
      });
      return;
    }

    const UserAttributes = [
      {
        Name: 'custom:family_name',
        Value: familyName,
      },
      {
        Name: 'custom:given_name',
        Value: givenName,
      },
      {
        Name: 'custom:country',
        Value: country,
      },
      {
        Name: 'custom:city',
        Value: city,
      },
      {
        Name: 'custom:job_title',
        Value: jobTitle,
      },
      {
        Name: 'custom:years_experience',
        Value: yearsExperience,
      },
      {
        Name: 'custom:salon',
        Value: salon,
      },
      {
        Name: 'custom:code',
        Value: isCodeValid,
      },
    ];

    this.setState(
      {
        loading: true,
        error: '',
      },
      () => {
        this.props.signUp(email.toLowerCase(), password, UserAttributes);
      }
    );
  };

  isValidSignUpForm = () => {
    const {
      familyName,
      givenName,
      country,
      city,
      jobTitle,
      yearsExperience,
      email,
      password,
      passwordMatch,
      inputValidationError,
    } = this.state;

    const isValid = !inputValidationError
      ? true
      : Object.keys(inputValidationError).reduce((prev, key) => {
          if (prev === true) return prev;
          return !inputValidationError[key];
        }, null);

    return (
      familyName.length >= 1 &&
      givenName.length >= 1 &&
      country.length > 0 &&
      city.length >= 1 &&
      jobTitle.length >= 1 &&
      yearsExperience.length >= 0 &&
      email.length > 0 &&
      password.length >= 1 &&
      passwordMatch === password &&
      isValid
    );
  };

  isValidCodeForm = () => {
    const { code } = this.state;
    return code.length >= 6;
  };

  registEmail = () => {
    console.log(this.setState);
    this.setState({ registType: 'email' });
  };

  render() {
    const { locale, copy, copyold, auth } = this.props;
    const {
      givenName,
      familyName,
      country,
      city,
      jobTitle,
      yearsExperience,
      email,
      password,
      passwordMatch,
      code,
      isCodeValid,
      loading,
      error,
      inputValidationError,
    } = this.state;

    return auth.hasSignedUp === state.AUTH_UNKNOWN ? (
      <Fragment>
        {/* {isCodeValid ? ( */}
        {this.state.registType === 'email' ? (
          <SignUpForm2
            auth={auth}
            givenName={givenName}
            familyName={familyName}
            country={country}
            city={city}
            jobTitle={jobTitle}
            yearsExperience={yearsExperience}
            email={email}
            password={password}
            passwordMatch={passwordMatch}
            copyold={copyold}
            copy={copy.signUp}
            common={copy.common}
            forgotPassword={copy.forgotPassword}
            locale={locale}
            isValidSignUpForm={this.isValidSignUpForm}
            onSignUp={this.handleSignUp}
            onInputChange={this.handleInputChange}
            loading={loading}
            error={error}
            inputValidationError={inputValidationError}
          />
        ) : (
          <CodeForm
            code={code}
            copy={copy.signUp}
            errorMessage={copy.errorMessage}
            locale={locale}
            isValidCodeForm={this.isValidCodeForm}
            onInputChange={this.handleInputChange}
            onCodeSubmit={this.handleCodeSubmit}
            handleSubmit={this.registEmail}
            isCodeValid={isCodeValid}
            loading={loading}
            error={error}
          />
        )}
      </Fragment>
    ) : (
      <SignedUp copy={copy} locale={locale} />
    );
  }
}

SignUpPage.defaultProps = {
  copy: {},
  copyold: {},
};

SignUpPage.propTypes = {
  copy: PropTypes.shape({}),
  copyold: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  auth: PropTypes.shape({
    hasSentCode: PropTypes.string,
    hasSignedUp: PropTypes.string,
    error: PropTypes.shape({
      message: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  // changePassword: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
  signUp: PropTypes.func.isRequired,
};

const mapState = state => ({
  copyold: state.siteOptions.siteCopyStylistToolSignUpPage,
  copy: state.salonConsultaionSiteOptions.siteCopy,
  locale: state.locale,
  auth: state.auth,
});

const mapDispatch = dispatch => ({
  signUp: (username, password, userAttributes) => dispatch(reducer.signUp(username, password, userAttributes)),
  init: () => dispatch(reducer.init()),
});

export default connect(mapState, mapDispatch)(SignUpPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SignUpPage/SignUpPage.js